var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#94A5F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_5474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9575 18.957H21.77V13.7695C21.77 12.9929 21.1404 12.3633 20.3638 12.3633C19.5871 12.3633 18.9575 12.9929 18.9575 13.7695V18.957H13.77C12.9934 18.957 12.3638 19.5866 12.3638 20.3633C12.3638 21.1399 12.9934 21.7695 13.77 21.7695H18.9575V26.957C18.9575 27.7337 19.5871 28.3633 20.3638 28.3633C21.1404 28.3633 21.77 27.7337 21.77 26.957V21.7695H26.9575C27.7342 21.7695 28.3638 21.1399 28.3638 20.3633C28.3638 19.5866 27.7342 18.957 26.9575 18.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9575 18.957H21.77V13.7695C21.77 12.9929 21.1404 12.3633 20.3638 12.3633C19.5871 12.3633 18.9575 12.9929 18.9575 13.7695V18.957H13.77C12.9934 18.957 12.3638 19.5866 12.3638 20.3633C12.3638 21.1399 12.9934 21.7695 13.77 21.7695H18.9575V26.957C18.9575 27.7337 19.5871 28.3633 20.3638 28.3633C21.1404 28.3633 21.77 27.7337 21.77 26.957V21.7695H26.9575C27.7342 21.7695 28.3638 21.1399 28.3638 20.3633C28.3638 19.5866 27.7342 18.957 26.9575 18.957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_5474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12.3638 12.3633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3ed12c2e6fb99c21c772cf55e9d7b17b.svg";
export { ForwardRef as ReactComponent };